// 登录
import React from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

interface IProps {
  onClick: () => void;
}

const Index: React.FC<IProps> = (props) => {
  return (
    <Button
      type="primary"
      htmlType="submit"
      className={styles.submitButton}
      onClick={props.onClick}
    >
      {intl.get('login_form_btn')}
    </Button>
  );
};

export default Index;
